import memoize from 'lru-memoize';
import {createValidator} from 'utils/validation';
import sitesForm from './sites.json';
import productForm from './product.json';

import * as validators from 'utils/validation';

import _ from 'underscore';

var validateSite = {};

_.each(sitesForm, (group)=>{
	_.each(group.inputs, (input)=>{
		validateSite[input.name] = input.rules.map(s => validators[s]);
	})
})

var validateProduct = {};
for(var group in productForm ) {
	var groupObj = productForm[group];
	for(var el in groupObj ) {
		
	  try {
	    validateProduct[groupObj[el].name] = groupObj[el].rules.map(s => validators[s]);
	  } catch(e) {
	    
	  }
	  
	  
	  
	}
}



const ficheValidation = createValidator([{sites:validateSite}, {products:validateProduct}]);

export default memoize(10)(ficheValidation);